import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ha',
    fullName: 'Hausa',
    nativeName: 'Hausa',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Wani Abin Mamaki Yana Zuwa",
    landing_subtitle: "ArgVoid app ne da ɗakin haɓaka wasan. Tsaya a hankali, sabbin abubuwa suna zuwa nan ba da jimawa ba!",
    select_language: "Zaɓi Harshe",
    search_placeholder: "Bincika harsuna...",
    terms_title: "Sharuɗɗan Sabis",
    policy_title: "takardar kebantawa",
    cookies_title: "Manufar Kuki",
    terms_content: `
        <strong>1. Karɓar Sharuɗɗan</strong><br>
        Ta hanyar shiga ArgVoid, ana karɓar waɗannan Sharuɗɗan Sabis. Idan waɗannan sharuɗɗan ba a yarda da su ba, bai kamata a yi amfani da sabis ɗin ba.<br><br>

        <strong>2. Platform Amfani</strong><br>
        Ana ba da ArgVoid da aikace-aikacen sa "kamar yadda yake" don dalilai na bayanai da ƙirƙira. Dole ne a yi amfani da sabis ɗin don dalilai na halal kawai.<br><br>

        <strong>3. Harukan da aka haramta</strong><br>
        An haramta amfani da rashin lahani na rukunin yanar gizon, yin zazzagewa, ko ƙoƙarin samun dama ga ababen more rayuwa mara izini.<br><br>

        <strong>4. Saukewa: </strong><br>
        Ana iya canza dandamali da sabis a kowane lokaci ba tare da sanarwa ba. Babu wani garanti da aka bayar dangane da lokacin aiki ko samuwan sabis ɗin.
    `,
    policy_content: `
        <strong>1. Tarin Bayani</strong><br>
        Dandalin baya buƙatar ingantaccen mai amfani ko ƙirƙirar asusu a wannan lokacin. Babu bayanin gano sirri (kamar sunaye ko adiresoshin imel) da aka karɓa daga maziyarta.<br><br>

        <strong>2. Amfani da Data</strong><br>
        Na asali, ana iya tattara bayanan da ba a bayyana sunansu ba don fahimtar zirga-zirgar rukunin yanar gizo da inganta aikace-aikacen. Ba a haɗa wannan bayanan zuwa ga ainihin mai amfani.<br><br>

        <strong>3. Sabis na ɓangare na uku</strong><br>
        Za a iya amfani da masu ba da izini na ɓangare na uku don sabis na tattarawa da nazari. Ayyukan sirri na waɗannan masu samarwa suna sarrafa bayanan da ba a san su ba da aka sarrafa akan kayan aikin su.<br><br>

        <strong>4. Bayanan Bayani na Security</strong>X17
        Ana aiwatar da matakan tsaro masu ma'ana don kare dandamali. Koyaya, babu wata hanyar watsawa akan Intanet gaba ɗaya amintacciyar hanya.<br><br>
    `,
    cookies_content: `
        <strong>1. Menene Kukis da Ma'ajiyar Gida?</strong><br>
        Kukis da ma'ajiyar burauzar gida ƙananan fayilolin bayanai ne da aka adana akan na'urar don tunawa da zaɓin daidaitawa a duk ziyarar.<br><br>

        <strong>2. Manufar Amfani</strong><br>
        Browser Local Storage ana amfani da shi sosai don adana saitunan sanyi, kamar:<br>
        - Zaɓin Harshe<br>
        - Tsarin keɓantawar mai amfani (misali, shimfidar wuri ko saitunan jigo)<br>
        - Cache na aikace-aikacen wucin gadi<br><br>

        <strong>3. Babu Tracking</strong><br>
        Ba a amfani da kukis da ma'ajiyar gida don talla ko dalilai na bin sawu na ɓangare na uku. Duk bayanan da aka adana an yi su ne don ainihin aikin dandamali.<br><br>

        <strong>4. Saukewa: Control</strong><br>
        Za a iya share bayanan mai lilo a kowane lokaci ta hanyar saitunan burauzar, wanda zai sake saita kowane saitin gida.
    `,
    cookie_consent_text: "Muna amfani da kukis na asali don tabbatar da ayyukan gidan yanar gizon daidai, kamar kiyaye zamanku yana aiki, adana zaɓin yaren ku, da sauran saitunan al'ada.",
    read_policy: "Karanta Manufar Kuki",
    support_title: "Tuntuɓi Support",
    support_subject_label: "Magana",
    support_message_label: "Sako",
    support_submit_button: "Aika Saƙo",
    support_hint: "Lura: Wannan zai buɗe tsoffin aikace-aikacen imel ɗin ku don aika saƙon.",
    support_success_msg: "Ana buɗe app ɗin imel ɗin ku...",
    support_error_msg: "An kasa aika sako. Da fatan za a sake gwadawa daga baya.",
    explorer_title: "Explorer",
    history_title: "Tarihi",
    animation_title: "Animation",
    config_title: "Kanfigareshan",
    tool_mouse: "Zaɓi (Ctrl+M)",
    tool_brush: "Brush (Ctrl+B)",
    tool_brush_mode: "Yanayin Juya (Mai ƙarfi/Bayanai)",
    tool_eraser: "Magogi (Ctrl+E)",
    tool_brush_size: "Daidaita Girman Goga",
    tool_bucket: "Cika (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Grid (Ctrl+Shift+B)",
    tool_rotate: "Juyawa (Ctrl+Shift+R)",
    tool_flip_h: "Juya H (Ctrl+Shift+H)",
    tool_flip_v: "Juya V (Ctrl+Shift+V)",
    tool_transpose: "Maida (Ctrl+Shift+T)",
    label_width: "Nisa",
    label_height: "Tsayi",
    label_frames: "Yawan Frames",
    label_animation: "Salon Animation",
    label_background_color: "Kalar Baya",
    label_interval: "Tazara",
    tool_anim_config: "Kanfigareshan Animation",
    label_new_width: "Sabon Nisa",
    label_new_height: "Sabon Tsayi",
    label_apply: "Aiwatar",
    label_colors: "Launuka",
    label_size: "Girman",
    label_tolerance: "Hakuri",
    val_horizontal: "A kwance",
    val_vertical: "A tsaye",
    val_sequence: "Jeri",
    val_bounce: "Billa",
    val_random: "Bazuwar",
    val_solid: "M",
    val_clear: "Share",
    action_add_sheet: "Sabon Shet",
    action_import: "Shigo da",
    action_export: "fitarwa",
    action_sort_projects: "Tsara",
    sort_date_old: "Mafi tsufa Na Farko",
    sort_date_new: "Sabon Farko",
    sort_name_az: "Suna (A-Z)",
    sort_name_za: "Suna (Z-A)",
    action_new_sprite: "Sabon Sprite",
    action_new_project: "Sabon Aikin",
    modal_save_all_title: "Ajiye Duk Canje-canje",
    modal_save_all_desc: "Zaɓi kadarorin don adanawa:",
    modal_save_selected: "Ajiye Zaɓaɓɓen",
    action_saved: "Ajiye",
    modal_create_sprite_title: "Ƙirƙiri Sabon Sprite",
    modal_create_project_title: "Ƙirƙiri Sabon Aiki",
    modal_add_sheet_title: "Ƙara Sabon Shet",
    modal_rename_sheet_title: "Sake suna Sheet",
    modal_rename_sprite_title: "Sake suna Sprite",
    modal_delete_sprite_title: "Share Sprite",
    modal_delete_project_title: "Share Project",
    modal_delete_sheet_title: "Share Shet",
    placeholder_sprite_name: "Suna",
    placeholder_project_name: "Suna",
    placeholder_sheet_name: "Suna",
    placeholder_new_name: "Sabon Suna",
    action_create: "Ƙirƙiri",
    action_add: "Ƙara",
    action_rename: "Sake suna",
    action_duplicate: "Kwafi",
    action_delete: "Share",
    action_cancel: "Soke",
    confirm_delete_sprite: "Shin kun tabbata kuna son share wannan sprite?",
    confirm_delete_project: "Shin kun tabbata kuna son share wannan aikin? Za a cire duk sprites.",
    confirm_delete_sheet: "Shin kun tabbata kuna son share wannan takardar?",
    err_select_sprite: "Da fatan za a fara zabar sprite.",
    err_select_project: "Da fatan za a fara zabar aikin.",
    err_name_empty: "Sunan ba zai zama fanko ba.",
    err_sprite_exists: "Akwai sprite mai wannan sunan.",
    err_project_exists: "Akwai wani aiki mai wannan sunan.",
    err_no_content: "Babu abun ciki don adanawa.",
    err_no_changes: "Babu canje-canje don adanawa.",
    err_delete_last_sheet: "Ba za a iya share takarda ta ƙarshe ba.",
    err_extract_frames: "An kasa cire kowane firam.",
    err_indexeddb: "An kasa yin ajiyar gida. Mai bincike naku bazai goyi bayan IndexedDB ba.",
    msg_upload_success: "An Yi Nasara Loda: {0}",
    msg_upload_failed: "An kasa Lodawa: {0}",
    msg_save_success: "Ajiye nasara.",
    msg_saving: "Ana ajiyewa...",
    msg_multi_save_result: "An adana kadarori {0} {1} gazawa.",
    menu_title: "Menu",
    menu_save: "Ajiye",
    menu_save_all: "Ajiye Duka",
    menu_support: "Tuntuɓi Support",
    label_local_storage: "Ma'ajiyar Gida",
    label_sign_in: "Shiga",
    modal_export_title: "Export Sprite",
    label_filename: "Sunan fayil",
    label_format: "Tsarin",
    action_export_confirm: "fitarwa",
};

export default translations;
